
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const Allahabad=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Allahabad - Prayagraj - Kumbh City </h1>
           <p className="sub-heading">Explore Prayagraj: The Sangam City, India’s Freedom history, much more</p>
         </div>
         <div className="description">
           

Prayagraj, formerly known as Allahabad, is one of India’s most revered spiritual and historical destinations, famous for the Triveni Sangam—the confluence of the Ganges, Yamuna, and the mythical Saraswati rivers. This sacred site attracts millions of pilgrims and devotees, especially during the grand Kumbh Mela, the largest religious gathering in the world. The city’s spiritual aura is enhanced by the presence of historic temples, including the Bade Hanuman Temple, Akshayavat (the immortal banyan tree), and the revered Alopi Devi Temple. Prayagraj is also a city of immense historical significance, having played a crucial role in India’s independence movement and serving as the birthplace of many freedom fighters. The majestic Allahabad Fort, built by Emperor Akbar in 1583, stands as a testament to the city’s Mughal heritage and offers breathtaking views of the Sangam. Anand Bhavan, the ancestral home of the Nehru family, provides a deep insight into India’s political history, while the All Saints Cathedral is a stunning example of colonial-era architecture. The city also boasts picturesque gardens like the Khusro Bagh, a Mughal-era burial complex with intricately designed tombs. Whether you seek divine blessings, historical marvels, or cultural richness, Prayagraj offers an unforgettable journey into India’s spiritual and historical legacy.

  </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Allahabad/122397602_389432748891751_2143168355458272826_n.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>

           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Allahabad/2021071343.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Allahabad/2021071373.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
        
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Allahabad/2021071384.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                  src={require('../../../media/tourism/other/Allahabad/2021071386.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/2021071395-1024x683.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/426506728_18253328017210704_983467313723212902_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/426563462_709718617982836_6702328954341516939_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/430878150_721838313437533_8365993422936757979_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/48409072_10156901237690365_3024004855850074112_n.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/Lete-hanuman-ji-prayagraj-1.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/pexels-narin-chauhan-295714705-16496146.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/pexels-pankaj-chauhan-356113212-30218191.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/pexels-pankaj-chauhan-356113212-30218192.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
                 src={require('../../../media/tourism/other/Allahabad/pexels-pk-pictures-2067451667-30020042.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
          
         </div>
   
         <BookSection />
       </div>
     );
};